import z from "zod";
import { mapErrorsToFields } from "../../../../utils";
import AllergyCategoryService from "../../../../services/AllergyCategoryService";

const api = new AllergyCategoryService();
export type State = {
  errors?: {
    name?: string[];    
    general?: string[];
  };
  message?: string | null;
  success?: boolean;
  defaultValues?: {
    name?: string;    
  };
};
const FormSchema = z.object({
  name: z.string().min(1, "Name is required."),  
});

export async function addCategory(
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
  };
  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Create Exercise Category.",
      };
    }
    const { name} = validatedFields.data;

    const result = await api.createAllergyCategory({ name });
    if (result.status == 201)
      return {
        message: "Allergy Category created successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to create allergy category.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to create allergy category.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}
export async function updateCategory(
    id: number,
  prevState: State,
  formData: FormData
): Promise<State> {
  const defaultValues = {
    name: formData.get("name")?.toString() ?? "",    
  };  
  try {
    const validatedFields = FormSchema.safeParse(defaultValues);

    if (!validatedFields.success) {
      return {
        success: false,
        errors: mapErrorsToFields(validatedFields.error),
        message: "Missing Fields. Failed to Update allergy Category.",
      };
    }
    const { name } = validatedFields.data;

    const result = await api.updateAllergyCategory({ id, name });
    if (result.status == 204)
      return {
        message: "Allergy Category updated successfully.",
        success: true,
        defaultValues: defaultValues,
        errors: {},
      };
    else
      return {
        message: "Failed to update allergy category.",
        success: false,
        errors: {},
        defaultValues: defaultValues,
      };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to update allergy category.",
      success: false,
      errors: {},
      defaultValues: defaultValues,
    };
  }
}

export async function deleteCategory(id: number, prevState: State) {
  try {
    await api.deleteAllergyCategory(id);
    return {
      message: "Allergy category deleted successfully.",
      success: true,
    };
  } catch (e) {
    console.log(e);
    return {
      message: "Failed to delete allergy category.",
      success: false,
    };
  }
}
